import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreditModal } from '../components/CreditModalContext';

/**
 * /studio/plan deep-link.
 *
 * The credit picker moved to a global modal that opens over the user's current
 * screen, so this route now just bounces them to the dashboard and pops the
 * modal. Kept so old bookmarks, support replies, and emails (e.g. "buy credits
 * at /studio/plan") still land somewhere useful.
 */
function PlanModal() {
  const navigate = useNavigate();
  const { openCreditModal } = useCreditModal();

  useEffect(() => {
    openCreditModal();
    navigate('/studio/dashboard', { replace: true });
  }, [navigate, openCreditModal]);

  return null;
}

export default PlanModal;
